import React, { ReactElement, useMemo, useState } from 'react';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Accordion as BootstrapAccordion,
  Card as BootstrapCard,
} from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import { Waypoint } from 'react-waypoint';
import { AccordionEventKey } from 'react-bootstrap/esm/AccordionContext';
import { Fader, SpeechBubble } from '../Common';
import AccordionItem from './AccordionItem';

import * as styles from './Accordion.module.css';

interface CustomToggleProps {
  children: ReactElement;
  eventKey: string;
}

const CustomToggle = ({ children, eventKey }: CustomToggleProps) => {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <button type="button" onClick={decoratedOnClick} className={styles.toggler}>
      {children}
    </button>
  );
};

interface AccordionProps {
  header: string | ReactElement;
  children: AccordionItem[];
}

/**
 * renders accordion
 */
const Accordion = ({ header = null, children }: AccordionProps) => {
  const [visible, setVisible] = useState(false);
  const [showSpeechBubble, setShowSpeechBubble] = useState(true);
  const [activeItemKeys, setActiveItemKeys] = useState<AccordionEventKey>([]);
  const random = useMemo(
    () => Math.floor(Math.random() * children.length + 0),
    [children],
  );

  const childrenData = children.map((child, index) => {
    const { speechBubbleMessage } = child.props;
    let speechBubble = null;
    if (speechBubbleMessage && index === random) {
      speechBubble = <SpeechBubble messages={speechBubbleMessage} />;
    }

    return (
      // eslint-disable-next-line react/no-array-index-key
      <BootstrapCard key={`card_${index}`}>
        <CustomToggle eventKey={index.toString()}>
          <BootstrapCard.Title
            className={classNames({
              collapsed: !activeItemKeys.includes(index.toString()),
            })}
          >
            {child.props.header}
            {speechBubble && (
              <Fader
                duration={500}
                fadeIn={visible && showSpeechBubble}
                // eslint-disable-next-line react/no-array-index-key
                key={`fader_${index}`}
                onExited={() => {
                  setShowSpeechBubble(false);
                }}
              >
                {speechBubble}
              </Fader>
            )}
          </BootstrapCard.Title>
        </CustomToggle>
        <BootstrapAccordion.Collapse eventKey={index.toString()}>
          <BootstrapCard.Body>{child.props.children}</BootstrapCard.Body>
        </BootstrapAccordion.Collapse>
      </BootstrapCard>
    );
  });

  return (
    <div className={classNames('ce', styles.ceAccordion)}>
      {header}
      <BootstrapAccordion alwaysOpen onSelect={(key) => setActiveItemKeys(key)}>
        {childrenData}
      </BootstrapAccordion>
      <Waypoint onEnter={() => setVisible(true)} />
    </div>
  );
};

export default Accordion;
